const zh_CN = {
    menu_home: "首页",
    menu_SpeRetrieve: "特色查询",
    menu_CLCRetrieve: "中图分类法查询",
    menu_AdvanceRetrieve: "高级检索",
    menu_BookMarkRetrieve: "书签检索",
    menu_Notes: "信息公告",
    menu_Link: "相关链接",
    menu_Mylibray: "我的图书馆",
    menu_Help: "帮助",
    menu_digitaltwins: "数字孪生",

    field_hit: '命中数',
    field_author: '责任者',
    field_pubdate: '出版时间',
    field_content: '丛书名',
    field_pages: '页数',
    field_publisher: '出版社',
    field_clcno: '分类号',
    field_price: '价格',
    field_barcode: '条码号',
    field_local: '馆藏地点',
    field_duedate: '应还日期',

    field_title: '题名',
    field_callno: '索书号',
    field_subject: '主题词',
    field_pubyear: '出版年',
    field_anyword: "任意词",
    field_cardno: '证号',
    field_rdrpin: '密码',
    field_fine: '过期欠款',
    field_suspendDays: '过期停借天数',
    field_logtype: '操作类型',
    field_logdate: '操作日期',
    field_begdate: '借出日期',


    field_frontMatch: "前方一致",
    field_exactMatch: "精确匹配",
    field_fuzzyRetrieve: "模糊检索",

    field_labelOrder: "排序顺序",
    field_orderAsc: "升序",
    field_orderDesc: "降序",

    field_tipInputKeyword: "请输入您要检索的关键词",
    field_retrieve: "检索",
    field_retrieveInReult: "在结果中检索",

    field_recordsPerPage: "每页显示",
    field_clc: "中图分类法",
    field_docType: "文献类型",
    field_language: "语种",

    field_mobileMessage: "发送短信",
    field_shareInfoTo: "分享至",
    field_shareQQ: "腾讯QQ",
    field_shareWeChat: "微信",
    field_shareWeibo: "新浪微博",
    field_tags: "标签",

    field_rdrfininfo: "读者财经信息",
    field_fin_cw: "读者证押金",
    field_fin_yy: "预付款",
    field_fin_fw: "普通外借欠款",
    field_fin_fz: "专项外借欠款",

    field_printPage: "打印",
    field_exportRec: "导出记录",
    field_addFavorite: "加到收藏夹",
    field_callno:"索取号",
    field_PermanentLink: "永久链接",
    field_btn_login: "登录",
    field_btn_back: "返回",
    field_btn_home: "返回主页",
    field_btn_cancelRecom: "取消荐购",
    field_btn_closewin: "关闭当前窗口",
    field_btn_action: "操作",
    field_btn_alipay: "支付宝",
    field_btn_webchatPay: "微信",
    field_contentSummary:"内容摘要",
    field_reasonRecommendation:"推荐原因",
    field_immeRecommendation:"立即推荐",

    field_mylib_bookshelf: "我的书架",
    field_mylib_loanlist: "我的借阅",
    field_mylib_reserveY: "我的预约",
    field_mylib_reserveJ: "我的预借",
    field_mylib_finInfo: "财经信息",
    field_mylib_loglist: "我的借阅史",
    field_mylib_searchCon: "您保存的检索",
    field_mylib_calendar: "我的图书馆日历",
    field_mylib_logout: '退出登录',
    field_mylib_readerCommand:'读者自荐',
    field_mylib_editFooter:'修改页脚内容',
    field_mylib_myCommend:'我的荐购',
    field_mylib_edit:'我的密码',
    field_resetRecommendation:"清空荐购内容",

    field_sortfield: "排序字段",
    field_tip_inputPin: "请输入您的密码",
    // 2024.1.24 zhonghh
    field_tip_remeber: "记住我",
    field_tip_logout: "您已安全的退出【我的图书馆】",
    field_tip_logoutDetail: "您可以继续浏览图书，感谢您的使用，期待下次与您相遇",

    detail_instance_author:"作者",
    detail_instance_Ethan:"ISBN",
    detail_instance_publicationInformation:"出版信息",
    detail_instance_Pages:"页 数",
    detail_instance_classificationNumber:"分类号",
    detail_instance_bookType:"图书类型",
    detail_instance_Books:"图书",
    detail_instance_periodical:"期刊",
    detail_instance_keyword:"关键词",
    detail_instance_callno:"索取号",
    detail_instance_seriesTitle:"丛书名",
    detail_instance_relatedResources:"相关资源",
    detail_instance_version:"版本",
    detail_instance_address:'出版地址',
    detail_instance_pub_date:'出版日期',
    detail_instance_price:'价格',
    detail_instance_publish:'出版社',
    detail_instance_coreRecord:'核心收录',
    detail_instance_subjectCategory:'学科分类',
    PageHoldingList_claimNumber:'索取号',
    PageHoldingList_place:'地点',
    PageHoldingList_circulationCategory:'流通类别',
    PageHoldingList_barcode:'条形码',
    
    ItemTab_pages:'页数',
    ItemTab_size:'尺寸',

    Bookshelf_delete:'删除',
    Bookshelf_recordNumber:'书目ID',
    Bookshelf_title:'题名',
    Bookshelf_author:'作者',
    Bookshelf_publish:'出版社',
    Bookshelf_pubDay:'出版日期',
    Bookshelf_price:'价格',
    Bookshelf_state:'书目状态',
    Bookshelf_addBookshelfTime:'加入书架时间',

    Loanlist_confirmRenewal:'确定续借',
    Loanlist_cenewAllLoans:'续借全部',
    Loanlist_barcode:'图书条码号',
    Loanlist_title:'图书名',
    Loanlist_collectionLocationName:'馆藏地点名称',
    Loanlist_LocationName:'所在馆名称',
    Loanlist_borrowingDate:'借书日期',
    Loanlist_returnDate:'还书日期',
    Loanlist_ISBN:'索书号',
    Loanlist_bookType:'图书类型',
    Loanlist_borrowingsNumber:'续借次数',
    Loanlist_renewalResult:'续借结果',

    Loglist_query:'查询',
    Loglist_borrowOrRepayamount:'借/还量',
    Loglist_operationType:'操作类型',
    Loglist_dateRange:'日期范围',
    Loglist_per_recordNumber:'每条记录显示数',
    Loglist_enterAnInquiry:'请输入查询',
    Loglist_loanDate:'借出日期',
    Loglist_dueDate:'截止日期',
    Loglist_returnDate:'还回日期',
    Loglist_barcode:'条形码',
    Loglist_title:'图书名',
    Loglist_lendingLocation:'所在借出图书科',
    field_parmemberVal:"所属图书馆",
    field_tip_inputParm:"请选择所在图书馆",
    field_reserveLogin: "预借登记",
    field_mylib_editPwd:"修改密码",
    field_check_pwd:"* 请至少使用字母、数字、符号两种类型组合的密码，长度为6~20位。",
    field_btn_comfirmPwd:"提交",
    field_btn_comfirm:"提交",
    field_verificationCode:"验证码",
    field_tip_verificationCode:"请输入验证码",
    field_tip_inputUserName:"请输入账户",
    field_mylib_bookCommend:"图书荐购",

    MyRecommand_index:'书目记录号',
    MyRecommand_title:'题名',
    MyRecommand_author:'作者',
    MyRecommand_operateDate:'操作日期',
    MyRecommand_operateTime:'操作时间',
    MyRecommand_noticeType:'通知类别',
    MyRecommand_recommendDate:'荐购日期',
    MyRecommand_memo:'附注',
    field_btn_comfirmBookRecom:'推荐图书',
    field_bookRecomandClassNo:'教育分类法',
    bookRecomand_enterAnInquiry:'请输入查询题名',
    MyRecommand_publish:'出版社',
    MyRecommand_pub_date:'出版日期',
    MyRecommand_type:'图书类型',
    detail_instance_link:"相关链接"
};

export default zh_CN;